import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../common/Button';
import MemoButton from '../common/MemoButton';
import { formatDateTime } from '../../utils/datetime';

interface LegalPersonReferenceItemProps {
    item: any;
    selectedPage: number;
    idx: number;
    showDetail: (idx: number) => void;
    showMemoModal: (value: number) => void;
}

const LegalPersonReferenceItem: React.FC<LegalPersonReferenceItemProps> = ({ item, selectedPage, idx, showDetail, showMemoModal }) => {
    const { t } = useTranslation(['verification']);

    return (
        <tr key={idx} className="group">
            <td>{item.corporateName}</td>
            <td>{item.corporateNumber}</td>
            <td>{item.applicantName}</td>
            <td>{formatDateTime(item.legalPersonReference_receivedDate)}</td>
            <td>{formatDateTime(item.legalPersonReference_verificationDate)}</td>
            <td
                className={item.legalPersonReference_result === "approved" ? 'status-completed' : (item.legalPersonReference_result === "denied" ? 'status-failed' : 'status-in-progress')}>
                <a href="#" className="no-underline hover:underline"
                   onClick={() => showDetail(idx)}
                >
                    {item.legalPersonReference_status === "verified" ? t(item.legalPersonReference_result) : t(item.legalPersonReference_status)}
                </a>
            </td>
            <td
                className={item.amlRiskCheck_result === "approved" ? 'status-completed' : (item.amlRiskCheck_result === "need_confirmation" ? 'status-failed' : 'status-in-progress')}>
                <a href="#" className="no-underline hover:underline"
                   onClick={() => showDetail(idx)}
                >
                    {item.amlRiskCheck_status === "completed" ? t(item.amlRiskCheck_result) : t(item.amlRiskCheck_status)}
                </a>
            </td>
            <td>
                <MemoButton
                    hasMemo={!!item.legalPersonReference_verificationMemo}
                    onClick={() => {
                        showMemoModal((selectedPage - 1) * 10 + idx);
                    }}
                />
            </td>
        </tr>
    );
};

export default memo(LegalPersonReferenceItem);
